import React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
/** Components */
import { PageHelper } from 'Components/PageHelper';
import { Card } from 'Components/Card';
import { Column, Row } from 'Components/Grid';
import { Container } from 'Components/Container';
import { CustomTextField } from 'Components/Form/styles';
import { DefaultTable } from 'Components/DefaultTable';
import { ModalConfirmDelete } from 'Components/ModalConfirmDelete';
import { NoData } from 'Components/NoData';
import { PageLoaderList } from 'Components/PageLoader/List';
import { tableHeader } from './table-header';
/** Services */
import { deletePolicy, getPoliciesPaged } from 'services/policies-service';
/** State Managers */
import { useAuthTenant, useAuthUser } from 'store/auth';
import { useSelector } from 'react-redux';
/** Third Lib Modal */
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { Pagination, Stack, Button } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

export const Policies = () => {
  const user = useSelector(useAuthUser);
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const [open, setOpen] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [statusFilter] = useState('');
  const { register, watch } = useForm({
    defaultValues: {
      searchContent: '',
    },
  });
  const getContentSearch = () => {
    if (!watch('searchContent')) return '';

    return watch('searchContent');
  };
  // Removido debounce: a busca só será aplicada ao clicar em "Filtrar"

  React.useEffect(() => {
    setPage(1);
    setRefetch(r => !r);
  }, [statusFilter]);

  console.log('StatusFilter:', statusFilter);
  const {
    isLoading,
    error,
    data: pagedPolicies,
  } = useQuery(['getPolicy', refetch, page, statusFilter], async () => {
    const result = await getPoliciesPaged(selectedTenant.slug, page, 15, getContentSearch(), statusFilter);
    console.log('Resultado da consulta:', result);
    if (result?.data.data.length > 0) {
      return result?.data;
    }
    return {
      data: [],
      page,
      totalPages: 0,
    };
  });

  const onDelete = item => {
    setItemToDelete(item);
    setOpen(true);
  };

  const onClose = () => {
    setItemToDelete(null);
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      const result = await deletePolicy(itemToDelete?._id);
      if (result.status === 204) {
        onClose();
        setRefetch(!refetch);
        SwalReact.fire({
          title: 'Sucesso!',
          text: 'Politica removida com sucesso',
          icon: 'success',
        });
      } else {
        throw new Error('Ocorreu um erro ao tentar remover a Política!');
      }
    } catch (error) {
      SwalReact.fire({
        title: 'Erro!',
        text: error.response.data.message ?? error.message,
        icon: 'error',
      });
    }
  };

  return (
    <Container title="Políticas" breadcrumb="Adequações / Políticas" showButtonAdd linkPage="/policies" data-tour="page-title">
      {isLoading && <PageLoaderList></PageLoaderList>}
      {error && <div>Ocorreu um erro ... {error.message}</div>}
      {!isLoading && !error && pagedPolicies.data?.length === 0 && (
        <>
          <Card className="mb-2 mt-3" data-tour="filter-card">
            <Row sx={{ alignItems: 'center' }}>
              <Column xs={12} md={8}>
              <div data-tour="filter-name" style={{ width: '100%' }}>
              <CustomTextField
                {...register('searchContent')}
                label="Buscar por nome"
                sx={{
                  minHeight: '40px',
                  maxHeight: '40px',
                  margin: '0 auto',
                  width: '100%',
                  ' > div': {
                    minHeight: '40px',
                  },
                }}
                InputLabelProps={{ shrink: true }}
                autoComplete="off"
                 />
              </div>
              </Column>
              <Column xs={12} md={4} style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <div data-tour="filter-button" style={{ width: '100%' }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    width: '120px',
                    borderRadius: '8px',
                    padding: '8px 20px',
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    height: '36px',
                    fontWeight: 500,
                  }}
                  endIcon={<SearchOutlinedIcon />}
                  onClick={() => { setPage(1); setRefetch(!refetch); }}
                >
                  Filtrar
                </Button>
                </div>
              </Column>
            </Row>
          </Card>
          <NoData description={'Não há Políticas para exibir'} />
        </>
      )}
      {!isLoading && !error && pagedPolicies.data?.length > 0 && (
        <div className="container">
          <Card className="mt-3" data-tour="filter-card">
            <Row sx={{ alignItems: 'center' }}>
              <Column xs={12} md={8}>
              <div data-tour="filter-name" style={{ width: '100%' }}>
              <CustomTextField
                {...register('searchContent')}
                label="Buscar por nome"
                sx={{
                  minHeight: '40px',
                  maxHeight: '40px',
                  width: '100%',
                  ' > div': {
                    minHeight: '40px',
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              </div>
              </Column>
              <Column xs={12} md={4} style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <div data-tour="filter-button" style={{ width: '100%' }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    width: '120px',
                    borderRadius: '8px',
                    padding: '8px 20px',
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    height: '36px',
                    fontWeight: 500,
                  }}
                  endIcon={<SearchOutlinedIcon />}
                  onClick={() => { setPage(1); setRefetch(!refetch); }}
                >
                  Filtrar
                </Button>
                </div>
              </Column>
              {/* <Column xs={12} md={4} style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <FormControl fullWidth size="small" variant="outlined" sx={{ m: 0, height: '40px', justifyContent: 'center' }}>
                  <InputLabel id="status-label" shrink>Filtrar por Status</InputLabel>
                  <Select
                    labelId="status-label"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    label="Filtrar por Status"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="Publicado">Publicado</MenuItem>
                    <MenuItem value="Concluído">Concluído</MenuItem>
                    <MenuItem value="Revisado">Revisado</MenuItem>
                  </Select>
                </FormControl>
              </Column> */}
            </Row>
          </Card>
          <div data-tour="table">
          <DefaultTable
            rows={tableHeader}
            cells={pagedPolicies.data}
            userId={user.userId}
            onClickDelete={onDelete}
            link="policies"
          />
          </div>
          <div data-tour="pagination">
          <Stack
            sx={{
              justifyContent: 'center',
              flexDirection: 'row',
              marginTop: '16px',
            }}
          >
            <Pagination
              count={pagedPolicies.totalPages}
              onChange={(_, selectedPage) => {
                setPage(selectedPage);
              }}
              color="primary"
              page={page}
              showFirstButton
              showLastButton
            />
          </Stack>
          </div>
          <ModalConfirmDelete
            description={
              <>
                Tem certeza que deseja excluir <strong>{` ${itemToDelete?.name} `}</strong> como ? de negócio?
              </>
            }
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
          />
        </div>
      )}
      <PageHelper steps={tourSteps} tourKey="policies-list" />
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo à página de Políticas! Aqui você gerencia as políticas de privacidade e conformidade da sua organização.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="page-title"] button',
    content: 'Use este botão para criar uma nova política de privacidade.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="filter-card"]',
    content: 'Use os filtros para encontrar políticas específicas. Você pode buscar pelo nome da política.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="filter-name"]',
    content: 'Digite o nome da política que deseja buscar.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="filter-button"]',
    content: 'Clique em "Filtrar" para aplicar a busca.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="table"]',
    content: 'Esta tabela exibe todas as políticas cadastradas. Você pode visualizar, editar ou excluir cada política.',
    disableScrolling: false,
  },
  {
    target: '[data-tour="pagination"]',
    content: 'Use a paginação para navegar entre as páginas quando houver muitas políticas.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Agora você conhece todas as funcionalidades da página de Políticas. Gerencie suas políticas de privacidade com facilidade.',
    disableScrolling: true,
    placement: 'center',
  },
];
